export const Administration_Wing = [
  {
    title: "JNTU-GV, DWARAPUDI, VIZIANAGARAM, Andhra Pradesh, INDIA,  535 003 " ,
    
  },
   {
    title: "Phone : 08922277388 " ,
    
  },
  {
    title: "Email : drnd@jntuk.edu.in" ,
    
  },
];

export const Central_Facilites = [
  {
    title: "About Us",
    link: "/about-us/aboutRND",
  },

  {
    title: "Administration",
    link: "/administration/chancellor",
  },
  {
    title: "Programs Offered",
    link: "/programs/programs-offered",
  },
  {
    title: "Academics",
    link: "/academics/codeofconduct",
  },
];


export const Constituent_Colleges = [
  {
    title: "Notifications",
    link: "/",
  },
  {
    title: "Online Payments",
    link: "/",
  },

  {
    title: "University",
    link: "/",
  },
  {
    title: "Others",
    link: "/",
  },
];



export const JntuGv_Units = [
  {
    title: "Tamen quem nulla quae legam multos aute sint culpa legam noster magna",
    link: "/",
  },
  
  
]

